import { render, staticRenderFns } from "./XigCheckHomePC.vue?vue&type=template&id=faf74584&scoped=true"
import script from "./XigCheckHomePC.vue?vue&type=script&lang=js"
export * from "./XigCheckHomePC.vue?vue&type=script&lang=js"
import style0 from "./XigCheckHomePC.vue?vue&type=style&index=0&id=faf74584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf74584",
  null
  
)

export default component.exports